locations-table
  section.app-table
    header.app-table-header
      .row
        .col-12.col-md-7 { opts.locale.header.name.label }
        .col-12.col-md-4 { opts.locale.header.to.label }
        .col-12.col-md-1.text-right
    .app-table-body
      .row(each="{ opts.items }")
        .col-12.col-md-7.address
          span.postcode(if="{postcode}") {postcode}
          br(if="{postcode}")
          span.state(if="{state}") {state}
          span.address3(if="{address3}") {address3 }
          span.address2(if="{address2}") {address2 }
          span.address1(if="{address1}") {address1 }
          br
          span.c_name1(if="{c_name1}") {c_name1 }
          span.c_name2(if="{c_name2}") {c_name2 }
        .col-12.col-md-4
          locations-people(items="{people}" new_path="{new_person_path}")
        .col-12.col-md-1.text-right
          a.btn.btn-primary.editable(href="{ edit_path }")
            i.feather.icon-edit
  shared-paginate(tag-scope="{this.tagScope}.paginate")
  script(type="typescript").
    this.mixin('table');
  style(scoped).
    :scope {
      display: block;
    }
    .address > span {
      display: inline-block;
      margin-right: .5rem;
    }
    .address > span.postcode {
      font-size: .75rem;
    }
